import React, { FC } from 'react';

import styled from '@emotion/styled';
import { variant } from '@lucid/theme';

import Icon from '../icon/icon';

export type VideoPlayerButtonVariant = 'small' | 'medium' | 'large';
export const videoPlayerButtonVariants = ['small', 'medium', 'large'];

export interface VideoPlayButtonProps {
  /** The available variants for the VideoPlayerButton component. */
  variant?: VideoPlayerButtonVariant;
  /** onClick handler to start the video. */
  onClick?: () => void;
  /** Sets the color of the play icon. */
  color?: string;
}

const PlayButton = styled.button(
  ({
    label: 'playButton',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    border: 0,
    position: 'relative',
    background: 'white',
    cursor: 'pointer',
    boxShadow: '0 2px 4px 2px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.15s ease-out',
    '&:hover': {
      transform: 'scale(1.1)'
    }
  }),
  variant({
    scale: 'videoPlayer.button',
    variants: {
      defaultVariant: {}
    }
  })
);

const IconContainer = styled.div(
  ({
    label: 'iconContainer',
    position: 'relative'
  }),
  variant({
    scale: 'videoPlayer.container',
    variants: {
      defaultVariant: {}
    }
  })
);

const VideoPlayButton: FC<VideoPlayButtonProps> = ({
  variant = 'medium',
  color = 'primary',
  ...rest
}) => (
  <PlayButton variant={variant} {...rest} aria-label="Play video">
    <IconContainer variant={variant}>
      <Icon
        color={color}
        sizing="responsive"
        type="Play"
      />
    </IconContainer>
  </PlayButton>
);

export { VideoPlayButton };
export default VideoPlayButton;
